module.exports = __webpack_public_path__ + "static/media/no-transactions.8c515715.svg";